import { getParticleFromText } from '@util/text';
import { TicketTypeLabel } from '@util/ticket';

/**
 * 이용권 관련
 * TicketList.tsx, BackofficeUserManagement.tsx 등에서 공유하여 사용
 */

// 확인 다이얼로그 메시지
export const TICKET_CONFIRM_MESSAGES = {
  BLOCK: '입장권을 차단하시겠습니까?\n입장권을 차단할 경우 자동으로 퇴장 처리됩니다.',
  UNBLOCK: '입장권을 차단 해제하시겠습니까?',
  FORCE_EXIT: '퇴장처리를 하시겠습니까?',
  OVERTIME_CANCEL:
    '초과결제를 해제하시겠습니까?\n초과결제 해제시 해당 이용권은 퇴장완료로 변경됩니다.',
} as const;

// 성공 메시지
export const TICKET_SUCCESS_MESSAGES = {
  BLOCK: '입장권 차단이 완료되었습니다.',
  UNBLOCK: '입장권 허용이 완료되었습니다.',
  FORCE_EXIT: '퇴장처리가 완료되었습니다.',
  OVERTIME_CANCEL: '초과 결제 해제가 완료되었습니다.',
} as const;

// 경고/오류 메시지
export const TICKET_WARNING_MESSAGES = {
  OVERTIME_REQUIRED: '초과결제를 해야합니다. 초과결제를 처리하신 후 다시 시도해주세요',

  EXPIRED_TICKET:
    '이미 만료되어 퇴장처리가 불가능한 이용자입니다.\n초과결제 취소가 필요한 경우 퇴장여부의 초과결제 취소를 눌러주세요.',
} as const;

// 버튼 텍스트
export const TICKET_BUTTON_TEXT = {
  BLOCK: '차단',
  UNBLOCK: '차단 해제',
  EXIT: '퇴장',
  OVERTIME_CANCEL: '초과결제 해제',
  CANCEL: '취소',
} as const;

// 툴팁 메시지
export const TICKET_TOOLTIP_MESSAGES = {
  EXPIRED: '유효기간이 만료된 이용권입니다.',
  NO_REMAIN_TIME_UNBLOCK: '잔여시간이 없어 차단 해제가 불가능합니다.',
  NO_REMAIN_TIME_BLOCK: '잔여시간이 없는 이용권입니다.',
  CANNOT_CHANGE_STATE: '이용권 상태로 인해 변경이 불가능합니다.',
} as const;

/**
 * 이용권 차단/해제 토글 비활성화 시 표시할 툴팁 메시지 반환
 * @param ticket - 이용권 정보
 * @param isExpired - 유효기간 만료 여부 (today_diff <= 0)
 */
export const getBlockTooltipMessage = (
  ticket: {
    type: number;
    block: number;
    remainTime: number;
  },
  isExpired: boolean,
): string => {
  const isBlocked = ticket.block === 1;
  const hasNoRemainTime = ticket.remainTime <= 0;
  const isUnblockableType = [1, 4, 5].includes(ticket.type); // 일회권, 세미나실, 사물함

  if (isExpired) {
    return TICKET_TOOLTIP_MESSAGES.EXPIRED;
  }

  if (isBlocked) {
    // 차단된 상태에서 해제 불가 케이스
    if (isUnblockableType) {
      const typeName = TicketTypeLabel[ticket.type] || '이용권';
      const particle = getParticleFromText(typeName, '은');
      return `${typeName}${particle} 차단 해제가 불가능합니다.`;
    }
    if (hasNoRemainTime) {
      return TICKET_TOOLTIP_MESSAGES.NO_REMAIN_TIME_UNBLOCK;
    }
  } else {
    // 차단되지 않은 상태에서 차단 불가 케이스 (사물함 제외)
    if (ticket.type !== 5 && hasNoRemainTime) {
      return TICKET_TOOLTIP_MESSAGES.NO_REMAIN_TIME_BLOCK;
    }
  }

  return TICKET_TOOLTIP_MESSAGES.CANNOT_CHANGE_STATE;
};
